import styled from 'styled-components';

const calendarWidth = 315;
const cellMargin = 10;

export const PlannedListGrid = styled.div`
  display: grid;
  grid-template-columns: ${calendarWidth}px 1fr;

  @media ${(props) => props.theme.device.mobileL} {
    display: block;
  }
`;

export const CalendarContainer = styled.div`
  width: fit-content;
  max-width: 100%;
  @media ${(props) => props.theme.device.mobileL} {
    margin: auto;
    max-width: 400px;
  }

  .react-calendar {
    width: ${calendarWidth}px;
    min-width: ${calendarWidth}px;
    max-width: ${calendarWidth}px;
    min-height: 365px;
    padding: 10px;
    box-shadow: 0px 4px 20px rgba(104, 104, 104, 0.1);
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.textPrimary};
    border: none;
    font-family: ${({ theme }) => theme.fontset.titillium};

    @media ${(props) => props.theme.device.mobileL} {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
    }

    .react-calendar__tile,
    .react-calendar__navigation__label,
    .react-calendar__navigation__arrow,
    .react-calendar__month-view__days__day,
    .react-calendar__month-view__days__day--weekend {
      color: ${(props) => props.theme.colors.textPrimary};
    }

    .react-calendar__month-view__days__day--neighboringMonth {
      visibility: hidden;
      color: ${(props) => props.theme.colors.textSecondary} !important;
    }

    .react-calendar__navigation {
      background: ${(props) => props.theme.colors.white};
      margin-bottom: 0px;
      border-radius: 4px;

      .react-calendar__navigation__label {
        font-size: 26px;
        text-transform: capitalize;
      }
    }

    .react-calendar__navigation__next-button,
    .react-calendar__navigation__prev-button {
      font-size: 24px;
    }

    .react-calendar__navigation .react-calendar__navigation__prev2-button {
      display: none;
    }
    .react-calendar__navigation .react-calendar__navigation__next2-button {
      display: none;
    }

    .react-calendar__month-view__weekdays__weekday > abbr[title] {
      cursor: default;
    }
    abbr[title],
    abbr[data-original-title] {
      text-decoration: none;
    }
    .react-calendar__tile {
      text-align: center;
      height: 32px;
      margin: 5px ${cellMargin}px 5px;
      margin-right: ${cellMargin}px !important;
      max-width: ${(calendarWidth - 20) / 7 - cellMargin * 2}px !important;
      padding: 0;
      position: relative;

      @media ${(props) => props.theme.device.tabletL} {
        max-width: calc((100% / 7) - (${cellMargin}px * 2)) !important;
      }
      @media ${(props) => props.theme.device.mobileL} {
        max-width: calc(min(400px, 100%) / 7 - ${cellMargin * 2}px) !important;
      }

      &.active {
        &:after {
          content: '';
          position: absolute;
          bottom: 2px;
          left: 50%;
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: ${(props) => props.theme.colors.brownGrey};
        }
      }
    }

    .react-calendar__tile--now.react-calendar__tile--active,
    .react-calendar__tile--now {
      background: ${(props) => props.theme.colors.greyLight};
      color: ${(props) => props.theme.colors.black};
      border-radius: 50%;
      margin: 6px auto 0 !important;
      margin-right: auto !important;
      min-width: 29px;
      height: 29px;
    }

    .react-calendar__tile--active,
    .react-calendar__tile:enabled:hover {
      background-color: transparent;
    }
    .react-calendar__tile--now:enabled:hover {
      background-color: ${(props) => props.theme.colors.bgSecondary};
      color: ${(props) => props.theme.colors.textPrimary};
      border: 1px solid ${(props) => props.theme.colors.border};
    }

    .react-calendar__tile--now.selected,
    .react-calendar__tile.selected {
      background-color: ${(props) => props.theme.colors.calendar}!important;
      color: ${(props) => props.theme.colors.white}!important;
      border-radius: 50%;
      margin: 6px auto 0 !important;
      margin-right: auto !important;
      min-width: 29px;
      height: 29px;
      &.active {
        &:after {
          background-color: ${(props) => props.theme.colors.white};
        }
      }
    }

    .react-calendar__navigation button:enabled:hover,
    .react-calendar__navigation button:enabled:focus {
      background-color: transparent;
    }

    .react-calendar__tile.active::after {
      left: 45%;
    }

    .react-calendar__month-view__weekdays {
      border-bottom: 1px solid ${(props) => props.theme.colors.gray};
    }
    .react-calendar__month-view__weekdays__weekday {
      padding: 15px 12px 10px 12px;
    }
  }
`;

export const BoxContainer = styled.div`
  color: ${(props) => props.theme.colors.textPrimary};
  box-shadow: 0px 4px 20px rgba(104, 104, 104, 0.1);
  border-radius: 4px;
`;

export const Header = styled.div`
  width: 100%;
  padding: 20px 20px 15px 20px;
  color: ${(props) => props.theme.colors.white};
  background-color: ${(props) => props.theme.colors.calendar};
  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
  }
`;

export const Body = styled.div`
  padding: 0 24px 0 24px;
  margin: 8px 12px 8px 0;
  max-height: 262px;
  height: 262px;
  overflow-y: auto;
  position: relative;

  > div:first-child {
    padding-top: 0;
  }

  &::-webkit-scrollbar {
    width: 5px;
    border-radius: 4px;
  }
  /* Track */
  &::-webkit-scrollbar-track {
    background: #eeeeee;
    border-radius: 4px;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #acacac;
    border-radius: 4px;
  }
  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #acacac;
  }
`;

export const SelectedDate = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-top: 12px;
`;

export const NumEvents = styled.div`
  & > div {
    display: inline;
    font-size: 16px;
  }

  div:first-child {
    font-weight: bold;
  }
`;

export const NoResultContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const ViewMore = styled.div`
  margin: 25px auto;
  text-align: center;
  width: 100%;

  div[data-vocabulary='viewMore'] {
    width: fit-content;
    margin: 0 auto;
    cursor: pointer;
  }
`;

export const SecondaryContainer = styled.div`
  padding: 50px 0;
  background-color: ${(props) => props.theme.colors.bgSecondary};
`;

export const EventCard = styled.div`
  margin-bottom: 8px;
  padding: 4px 0 8px;
  border-bottom: 1px solid ${(props) => props.theme.colors.border};

  .title {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .info {
    display: flex;
    align-items: center;
    gap: 27px;
    font-size: 13.781px;
    font-style: normal;
    font-weight: 600;
    line-height: 19.688px;
    color: #8b8b8b;

    svg {
      stroke: #8b8b8b;
    }
  }
`;
